import React from 'react'
import { withAuthorization } from '../session';
import LegislationItem from './LegislationItem';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal'
import EmptyList from '../useful/EmptyList';
import LegislationForm from './LegislationForm';

Modal.setAppElement('#root');
class Legislation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            legislations: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenLegislations();
    }

    componentWillUnmount() {
        this.props.firebase.legislations().off();
    }

    listenLegislations = () => {
        this.props.firebase.legislations().off();
        this.props.firebase.legislations().on('value', (snapshot) => {
            const legislationObject = snapshot.val();
            // console.log(legislationObject);
            let list = [];
            if (legislationObject) {
                list = Object.keys(legislationObject).map(key => ({
                    ...legislationObject[key],
                    uid: key,
                }));
            }
            this.setState({
                legislations: list,
                loading: false,
            });

        });
    }

    handleUploadFile = (fileUrl, item) => {
        this.props.firebase.legislation(item.uid)
            .set({
                title: item.title,
                type: item.type,
                fileUrl: fileUrl,
            })
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, ocurrió un error al subir el archivo.");
            });
    }

    handleSubmit = (type, title) => {
        this.props.firebase.legislations().push({
            type: type,
            title: title
        }).then(() => {
            // do nothing
        }).catch(error => {
            this.showErrorModal("Los sentimos, no se pudo crear este elemento.");
            console.log(error);
        });
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.legislation(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar este elemento.");
                console.log(error);
            });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {
        const { legislations, loading, error } = this.state;
        const time = new Date().getTime();

        let categories = legislations.map((item, i) => {
            return item.type;
        });
        categories = [...new Set(categories)];

        const legislationList = categories.length > 0 ?
            categories.map((type, i) => {
                let legislationByType = legislations.filter((v, i) => v.type === type);
                legislationByType.sort((a,b)=>{
                    return a.title.localeCompare(b.title);
                });

                const legislationItems = legislationByType.map((item, i) => {
                    return (
                        <LegislationItem
                            key={item.uid + time}
                            item={item}
                            handleDelete={this.handleDelete}
                            handleUploadFile={this.handleUploadFile}
                            showErrorModal={this.showErrorModal} />
                    )
                });
                return (

                    <div key={type} className="table-responsive-md">
                        <div className="nav justify-content-center font-weight-bold">{type}</div>
                        <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        <th className="pr-2 pl-2" scope="col">Archivo</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {legislationItems}
                                </tbody>
                            </table>
                    </div>

                )
            }) : <EmptyList />;

        return (
            <div >
                <LegislationForm key={time} handleSubmit={this.handleSubmit} />

                <div>
                    <h5 >Legislación: listado de archivos</h5>

                    {(!loading) ?
                        <div>
                            {legislationList}
                        </div>

                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }
                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }

}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Legislation);